export function checkElement(_element: unknown): HTMLElement | Text {
  if (_element instanceof HTMLElement) {
    return _element;
  } else {
    console.warn(`${_element} is not an HTMLElement`);

    return document.createTextNode('');
  }
}
